var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"soha-selected-filter"},[_c('limited-text',{attrs:{"limit":30,"text":_vm.label}}),_c('span',{staticClass:"svg-icon svg-icon-md svg-icon-secondary my-auto cursor-pointer ml-2",on:{"click":function($event){return _vm.$emit('click')}}},[_c('inline-svg',{attrs:{"src":"/media/svg/soha/icons/times.svg"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }